import React, { Component } from 'react'
import ReactHighcharts from 'react-highcharts'
import { injectIntl } from 'react-intl'
import messages from './messages'

import LinesChartConfig from './LinesChartConfig'
import LinesChartAdapter from './LinesChartAdapter'

import API from 'utils/api/api'
import APIURL from 'utils/api/urls'
import API_V1_URL from 'utils/api/urls_v1'
import AppTools from 'utils/app/appTools'
import QueryTools from 'utils/queries/queryTools'
import RegionTools from 'utils/regions/regionTools'
import Colors from 'utils/colors/colors'
import ObjectTools from 'utils/objects/objectTools'

import Loading from 'components/Loading'
import Error from 'components/Error'

class LinesChart extends Component {
	constructor(props) {
		super(props)

		const {
			intl: { formatMessage, formatNumber }
		} = props
		this.formatMessage = formatMessage
		this.formatNumber = formatNumber
		AppTools.importFormatter(formatMessage)

		this.state = {
			loading: true,
			error: false
		}
		this.chartRef = React.createRef()
	}

	componentDidMount() {
		this.props.fn(this.chartRef)
		const generalRegionsData = JSON.parse(this.props.generalRegionsData)
		const { regionsData, referenceRegionsData, sameCountryRegionsData, comparative, allRegionsGroupRegionId } = generalRegionsData

		this.setState(
			{
				regionsData,
				referenceRegionsData,
				sameCountryRegionsData,
				comparative,
				allRegionsGroupRegionId
			},
			() => {
				this.getLinesChart()
			}
		)
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (this.props.showLegend !== nextProps.showLegend) return false
		const shouldUpdate = !ObjectTools.compareObjects(this.props, nextProps) || !ObjectTools.compareObjects(this.state, nextState)
		return shouldUpdate
	}

	componentDidUpdate(prevProps) {
		if (!ObjectTools.compareObjects(this.props, prevProps)) {
			const generalRegionsData = JSON.parse(this.props.generalRegionsData)
			const { regionsData, referenceRegionsData, sameCountryRegionsData, comparative, allRegionsGroupRegionId } = generalRegionsData
			this.setState(
				{
					regionsData,
					referenceRegionsData,
					sameCountryRegionsData,
					comparative,
					allRegionsGroupRegionId,
					loading: true,
					error: false
				},
				() => this.getLinesChart()
			)
		}
	}

	getLinesChart = ({ indicator, selectedRegionId } = { indicator: this.props.indicator, selectedRegionId: this.props.selectedRegionId }) => {
		let regionsData = this.state.regionsData
		// let referenceRegionsData = this.state.referenceRegionsData
		//   let sameCountryRegionsData = this.state.sameCountryRegionsData
		let comparative = this.state.comparative
		let allRegionsGroupRegionId = this.state.allRegionsGroupRegionId

		const linesToShow = JSON.parse(this.props.linesToShow)
		const { allRegionsFilter, /* referenceRegionsFilter, */ sameCountryRegionsFilter, otherRegionsFilter } = linesToShow
		let comparativeShouldShow = Object.keys(otherRegionsFilter).length !== 0
		const showByGender = this.props.showByGender
		let indicatorFemale = 0
		let indicatorMale = 0
		if (showByGender) {
			indicatorFemale = this.props.indicatorData.relationships.sexFemale
			indicatorMale = this.props.indicatorData.relationships.sexMale
		}

		let chartConfig = this.selectConfig('selectedRegion').chartConfig

		const promises = []

		// This is the line of the selected region
		if (true) {
			const chartColor = this.selectConfig('selectedRegion').chartColor
			// const query = QueryTools.formatQuerySingleGEOFromId(selectedRegionId)
			let geo = [selectedRegionId];

			if (!showByGender) {
				const promise = Promise.resolve(
					// API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query })).then(data =>
					API.getQuery(API_V1_URL.getIndicatorData({ indicator, geo })).then(data =>
						LinesChartAdapter.formatLinesSeries({
							name: RegionTools.getRegionNameFromId({ regionsData, id: selectedRegionId }),
							data,
							color: chartColor,
							startingYear: this.props.startingYear,
							endingYear: this.props.endingYear,
							formatMessage: this.formatMessage
						})
					)
				)
				promises.push(promise)
			} else {
				const promiseFemale = Promise.resolve(
					API.getQuery(API_V1_URL.getIndicatorData({ indicator: indicatorFemale, geo })).then(data =>
						LinesChartAdapter.formatLinesSeries({
							name: RegionTools.getRegionNameFromId({ regionsData, id: selectedRegionId }),
							data,
							color: chartColor,
							gender: 'Female',
							startingYear: this.props.startingYear,
							endingYear: this.props.endingYear,
							formatMessage: this.formatMessage
						})
					)
				)
				const promiseMale = Promise.resolve(
					API.getQuery(API_V1_URL.getIndicatorData({ indicator: indicatorMale, geo })).then(data =>
						LinesChartAdapter.formatLinesSeries({
							name: RegionTools.getRegionNameFromId({ regionsData, id: selectedRegionId }),
							data,
							color: chartColor,
							gender: 'Male',
							startingYear: this.props.startingYear,
							endingYear: this.props.endingYear,
							formatMessage: this.formatMessage
						})
					)
				)
				promises.push(promiseFemale)
				promises.push(promiseMale)
			}
		}

		if (allRegionsFilter) {
			let chartColor = this.selectConfig('allRegions').chartColor
			// let query = undefined
			// if (allRegionsGroupRegionId === undefined) {
			// 	query = QueryTools.formatQueryInSameGEO(regionsData)
			// } else {
			// 	query = QueryTools.formatQuerySingleGEOFromId(allRegionsGroupRegionId)
			// }
			let geo = [allRegionsGroupRegionId];

			if (!showByGender) {
				const promise = Promise.resolve(
					// API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query })).then(data =>
					API.getQuery(API_V1_URL.getIndicatorData({ indicator, geo })).then(data =>
						LinesChartAdapter.formatLinesSeries({
							name: this.formatMessage(messages.euAcronym),
							data,
							color: chartColor,
							startingYear: this.props.startingYear,
							endingYear: this.props.endingYear,
							formatMessage: this.formatMessage
						})
					)
				)
				promises.push(promise)
			} else {
				const promiseFemale = Promise.resolve(
					API.getQuery(API_V1_URL.getIndicatorData({ indicator: indicatorFemale, geo })).then(data =>
						LinesChartAdapter.formatLinesSeries({
							name: this.formatMessage(messages.euAcronym),
							data,
							color: chartColor,
							gender: 'Female',
							startingYear: this.props.startingYear,
							endingYear: this.props.endingYear,
							formatMessage: this.formatMessage
						})
					)
				)
				const promiseMale = Promise.resolve(
					API.getQuery(API_V1_URL.getIndicatorData({ indicator: indicatorMale, geo })).then(data =>
						LinesChartAdapter.formatLinesSeries({
							name: this.formatMessage(messages.euAcronym),
							data,
							color: chartColor,
							gender: 'Male',
							startingYear: this.props.startingYear,
							endingYear: this.props.endingYear,
							formatMessage: this.formatMessage
						})
					)
				)
				promises.push(promiseFemale)
				promises.push(promiseMale)
			}
		}

		if (sameCountryRegionsFilter) {
			let chartColor = this.selectConfig('sameCountryRegions').chartColor

			let selectedRegionData = regionsData.filter(item => item.id === selectedRegionId)[0]
			let selectedCountryCode = RegionTools.getCountryCodeFromRegionCode(selectedRegionData.code)
			let selectedCountryMeta = RegionTools.countryCodeToMeta(selectedCountryCode);
			let selectedCountryName = RegionTools.countryCodeToFullName(selectedCountryCode)

			// let query = QueryTools.formatQuerySingleGEOFromId(selectedCountryMeta.id);

			let geo = [selectedCountryMeta.id];

			if (!showByGender) {
				const promise = Promise.resolve(
					API.getQuery(API_V1_URL.getIndicatorData({ indicator: indicator, geo })).then(data =>
						// API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query })).then(data =>
						LinesChartAdapter.formatLinesSeries({
							name: selectedCountryName,
							data,
							color: chartColor,
							startingYear: this.props.startingYear,
							endingYear: this.props.endingYear,
							formatMessage: this.formatMessage
						})
					)
				)
				promises.push(promise)
			} else {
				const promiseFemale = Promise.resolve(
					API.getQuery(API_V1_URL.getIndicatorData({ indicator: indicatorFemale, geo })).then(data =>
						// API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator: indicatorFemale, query })).then(data =>
						LinesChartAdapter.formatLinesSeries({
							name: selectedCountryName,
							data,
							color: chartColor,
							gender: 'Female',
							startingYear: this.props.startingYear,
							endingYear: this.props.endingYear,
							formatMessage: this.formatMessage
						})
					)
				)
				const promiseMale = Promise.resolve(
					API.getQuery(API_V1_URL.getIndicatorData({ indicator: indicatorMale, geo })).then(data =>
						LinesChartAdapter.formatLinesSeries({
							name: selectedCountryName,
							data,
							color: chartColor,
							gender: 'Male',
							startingYear: this.props.startingYear,
							endingYear: this.props.endingYear,
							formatMessage: this.formatMessage
						})
					)
				)
				promises.push(promiseFemale)
				promises.push(promiseMale)
			}
		}

		if (comparativeShouldShow) {
			comparative.forEach((comparativeItem, index) => {
				let chartColor = this.selectConfig('otherRegions', index).chartColor
				//   let query = QueryTools.formatQueryInSameGEO(comparativeItem.regionsData)
				let query = QueryTools.formatQuerySingleGEOFromId(comparativeItem.regionId);
				let name = comparativeItem.isCountry ? comparativeItem.countryFullName : comparativeItem.regionsData[0].name

				if (!showByGender) {
					const promise = Promise.resolve(
						API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query })).then(data =>
							LinesChartAdapter.formatLinesSeries({
								name,
								data,
								color: chartColor,
								startingYear: this.props.startingYear,
								endingYear: this.props.endingYear,
								dashedLine: true,
								formatMessage: this.formatMessage
							})
						)
					)
					promises.push(promise)
				} else {
					const promiseFemale = Promise.resolve(
						API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator: indicatorFemale, query })).then(data =>
							LinesChartAdapter.formatLinesSeries({
								name,
								data,
								color: chartColor,
								gender: 'Female',
								startingYear: this.props.startingYear,
								endingYear: this.props.endingYear,
								dashedLine: true,
								formatMessage: this.formatMessage
							})
						)
					)
					const promiseMale = Promise.resolve(
						API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator: indicatorMale, query })).then(data =>
							LinesChartAdapter.formatLinesSeries({
								name,
								data,
								color: chartColor,
								gender: 'Male',
								startingYear: this.props.startingYear,
								endingYear: this.props.endingYear,
								dashedLine: true,
								formatMessage: this.formatMessage
							})
						)
					)
					promises.push(promiseFemale)
					promises.push(promiseMale)
				}
			})
		}

		Promise.all(promises)
			.then(values => {
				let customLinesConfig = ObjectTools.copyObject(chartConfig)

				console.log(values);

				customLinesConfig.series = values
				if (this.props.expanded) {
					let panelHeight = document.querySelector('.panel-expanded').offsetHeight
					let panelHeaderHeight = document.querySelector('.panel-expanded>.panel-heading').offsetHeight
					let panelFooterHeight = document.querySelector('.panel-expanded>.panel-footer').offsetHeight
					let panelBody = document.querySelector('.panel-expanded>.panel-body')
					let paddingTop = parseInt(window.getComputedStyle(panelBody).getPropertyValue('padding-top'), 10)
					let paddingBottom = parseInt(window.getComputedStyle(panelBody).getPropertyValue('padding-bottom'), 10)
					let panelBodyHeight = panelHeight - panelHeaderHeight - panelFooterHeight - paddingTop - paddingBottom
					customLinesConfig.chart.height = `${panelBodyHeight}px`
				}

				customLinesConfig.legend.enabled = this.props.showLegend
				customLinesConfig.credits.text = AppTools.getComposedDataSource(this.props.indicatorData.dataSource)
				customLinesConfig.yAxis.title.text = this.props.indicatorData.unit
				const formatNumber = this.formatNumber
				const unit = this.props.indicatorData.unit
				customLinesConfig.tooltip.pointFormatter = function () {
					let tooltip = '<span style="color:' + this.color + '">●</span><b>' + this.series.name + '</b>: ' + formatNumber(this.y.toFixed(2)) + ' ' + unit;
					if ( this.notes ) {
						tooltip += '<br/>' + this.notes;
					}
					return tooltip;
				}

				this.setState({ chartConfig: customLinesConfig, loading: false })
			})
			.catch(reason => {
				this.setState({ error: true, loading: false })
			})
	}

	selectConfig = (config, index) => {
		switch (config) {
			case 'selectedRegion':
				return {
					chartConfig: LinesChartConfig.selectedRegionConfig,
					chartColor: Colors.selectedRegionColor
				}

			case 'allRegions':
				return {
					chartConfig: LinesChartConfig.allRegionsConfig,
					chartColor: Colors.allRegionsColor
				}

			case 'referenceRegions':
				return {
					chartConfig: LinesChartConfig.referenceRegionsConfig,
					chartColor: Colors.referenceRegionsColor
				}
			case 'sameCountryRegions':
				return {
					chartConfig: LinesChartConfig.sameCountryRegionsConfig,
					chartColor: Colors.sameCountryRegionsColor
				}
			case 'otherRegions':
				return {
					chartConfig: LinesChartConfig.otherRegionsConfig,
					chartColor: Colors.selectOtherRegionsColor(index)
				}

			default:
				return this.selectConfig('allRegions')
		}
	}

	renderIfAllOK = () => {
		let renderingComponent = null
		if (this.state.error) {
			renderingComponent = <Error />
		} else if (this.state.loading) {
			renderingComponent = <Loading />
		} else {
			renderingComponent = <ReactHighcharts ref={this.chartRef} config={this.state.chartConfig} />
		}
		return renderingComponent
	}
	render() {
		return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default injectIntl(LinesChart)



// WEBPACK FOOTER //
// ./src/modules/Charts/Lines/LinesChart/LinesChart.jsx